import React from 'react';
import clsx from 'clsx';
import { Radio as MuiRadio } from '@material-ui/core';

import useStyles from './useStyles';

const Radio = props => {
  const classes = useStyles();

  return (
    <MuiRadio
      className={classes.radioButton}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.radioIcon, classes.checkedIcon)} />}
      icon={<span className={classes.radioIcon} />}
      {...props}
    />
  );
};

export default Radio;



// WEBPACK FOOTER //
// ./src/sharedComponents/Radio/Radio.js